import '../css/index.css';
import './views/App';

document.querySelector('#app').innerHTML = '<app-wrapper></app-wrapper>';
